import { render } from "./NewsList.vue?vue&type=template&id=46a83438&scoped=true"
import script from "./NewsList.vue?vue&type=script&lang=js"
export * from "./NewsList.vue?vue&type=script&lang=js"

import "./NewsList.vue?vue&type=style&index=0&id=46a83438&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-46a83438"

export default script